module.exports = __webpack_public_path__ + "media/LobbyVideo.28a32f0b.mp4";